// 📁 src/redux/slices/DealBookBubOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface DealBookBubOption {
  label: string;
  value: string;
}

interface FetchDealBookBubParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
  ISBN?: any;
  TITLE?: any;
  DEAL?: any;
}

interface DealBookBubOptionsState {
  DealBookBubOption: any;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
}

// ✅ Initial State
const initialState: DealBookBubOptionsState = {
  DealBookBubOption: [],
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
};

export const FetchDealBookBub = createAsyncThunk(
  "FetchDealBookBub",
  async (params: FetchDealBookBubParams = {}, { rejectWithValue }) => {
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)
        queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
      if (Array.isArray(params.ISBN)) {
        params.ISBN.forEach((isbn) => {
          queryParams.push(`ISBN=${encodeURIComponent(isbn)}`);
        });
      }
      if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach((title) => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
      if (Array.isArray(params.DEAL)) {
        params.DEAL.forEach((file) => {
          queryParams.push(`DEAL_DATE=${encodeURIComponent(file)}`);
        });
      }

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GetBookBubDealOptions}${queryString}`
      );

      return {
        data: response.data,
        page: params.page ?? 1,
      };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const DealBookBubOptionsSlice = createSlice({
  name: "DealBookBubOptions",
  initialState,
  reducers: {
    clearDealBookBubOptions: (state) => {
      state.DealBookBubOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
      state.error = null;
    },
    // setLoadingofDealBookBub:(state,action)=>{
    //   state.LoadingofDealBookBub=action.payload
    // },
    // setLoadingofisbnookBub:(state,action)=>{
    //   state.LoadingofisbnBookBub=action.payload
    // },
    // setLoadingofDealBookBub:(state,action)=>{
    //   state.LoadingofDealBookBub=action.payload
    // }
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchDealBookBub.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchDealBookBub.fulfilled, (state, action) => {
        const { data, page } = action.payload;

        const formatted = (data.DEAL_DATE_options || []).map(
          (item: string) => ({
            label: item,
            value: item,
          })
        );
        console.log(formatted,"DEAL_DATE_options_options");
        if (page === 1) {
          state.DealBookBubOption = formatted;
        } else {
          state.DealBookBubOption = [
            ...state.DealBookBubOption,
            ...formatted,
          ];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loading = false;
      })
      .addCase(FetchDealBookBub.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Fetch failed";
      });
  },
});

export const { clearDealBookBubOptions} =
  DealBookBubOptionsSlice.actions;
export default DealBookBubOptionsSlice.reducer;
